<template>
  <div style="width: 100%; background-color: #fff">
    {{ props }} - {{ lead }}
    <v-form ref="form" @submit.prevent="submit">
      <v-container grid-list-xl fluid>
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="props.name"
              :rules="rules.name"
              color="purple darken-2"
              label="Nome"
              required
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field
              v-model="props.email"
              :rules="rules.email"
              color="blue darken-2"
              label="Email"
              required
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
<script>
export default {
  name: "Lead",
  data() {
    return {
      name: "Lead",
      props: {
        mylead: {},
      },
      form: "",
      lead: "",
      rules: {
        name: [
          (v) => !!v || "Por favor, informe o seu email",
          (v) => /.+@.+/.test(v) || "E-mail precisa ser válido",
        ],
        email: [
          (v) => !!v || "Por favor, informe o seu email",
          (v) => /.+@.+/.test(v) || "E-mail precisa ser válido",
        ],
      },
    };
  },
};
</script>
<style></style>
